import { getMqttSource } from '@/lib/mqtt/source';
import type { ConnectionState } from '@/lib/mqtt/types';
import { useEffect, useState } from 'react';

/** Subscribe to the shared MQTT source's connection state. */
export function useMqttState(): ConnectionState {
  const [state, setState] = useState<ConnectionState>(() => getMqttSource().getState());
  useEffect(() => {
    const src = getMqttSource();
    setState(src.getState());
    return src.onStateChange(setState);
  }, []);
  return state;
}
